
import { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProductCTA from "@/components/ProductCTA";
import { articlesArray } from "@/data/articles";
import BlogHeader from "@/components/blog/BlogHeader";
import SearchAndFilter from "@/components/blog/SearchAndFilter";
import ArticleGrid from "@/components/blog/ArticleGrid";
import NewsletterAndAffiliates from "@/components/blog/NewsletterAndAffiliates";

const categories = [
  "All",
  "Science",
  "Health",
  "Reviews",
  "Skin Care",
  "Research",
  "Treatments"
];

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  
  const filteredArticles = articlesArray.filter((article) => {
    const matchesCategory = selectedCategory === "All" || article.category === selectedCategory;
    const matchesSearch = searchTerm.trim() === "" || 
                          article.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          article.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Add fade-in effect on initial load
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const handleClearSearch = () => {
    setSelectedCategory("All");
    setSearchTerm("");
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className={`flex-grow transition-opacity duration-500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
        <BlogHeader 
          title="The Armpit Health Blog" 
          description="Latest articles, research, and advice for maintaining healthy underarms."
        />
        
        <SearchAndFilter 
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          categories={categories}
        />

        {/* Featured Product Banner - Updated to use It Just Works link */}
        <section className="py-4 md:py-6">
          <div className="container-custom">
            <ProductCTA 
              variant="banner" 
              message="Tired of Ineffective Deodorants? Try It Just Works!" 
              linkType="itjustworks"
            />
          </div>
        </section>

        <ArticleGrid 
          filteredArticles={filteredArticles}
          searchTerm={searchTerm}
          onClearSearch={handleClearSearch}
        />

        <NewsletterAndAffiliates />

        {/* Floating CTA - Updated to use It Just Works link */}
        <ProductCTA 
          variant="floating" 
          message="Tired of ineffective deodorants?" 
          linkType="itjustworks"
        />
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
